<template>
  <li>
    <router-link :to="{ name: 'users.edit', params: { id: user.id } }">
      <div class="row">
        <div class="col-12 col-sm-12 col-xl-5 d-flex align-items-center">
          <div>
            <p class="strong">{{ user.name }}</p>
            <p class="small text-muted">{{ user.email }}</p>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-xl-2 d-flex align-items-center">
          <p class="text-muted">
            <span class="data-label d-xl-none">GEN</span>
            {{ user.gen }}
          </p>
        </div>
        <div class="col-6 col-sm-4 col-xl-3 d-flex align-items-center">
          <p class="text-muted">
            <span class="data-label d-xl-none">User Type</span>
            {{ user.role | capitalise }}
          </p>
        </div>
        <div class="col-6 col-sm-4 col-xl-2 d-flex align-items-center">
          <p>
            <span class="data-label d-xl-none">Status</span>
            <span v-if="userIsDisabled" class="status status-danger">Disabled</span>
            <span v-else class="status status-success">Enabled</span>
          </p>
        </div>
      </div><!-- /.row -->
    </router-link>
  </li>
</template>

<script>
import { helpers } from 'mixins/users'

export default {
  mixins: [helpers],

  props: {
    user: {
      required: true,
      type: Object
    }
  }
}
</script>
